import ms from 'ms'

export const CT_DATA_KEY = 'customTokens'
export const CT_TIMESTAMP_KEY = 'customTokensLastUpdate'
export const CT_UPDATE_INTERVAL = ms('8h')
export const CT_FETCH_CACHE_EXPIRY = ms('1h')
export const CTR_TOKENS_LIMIT = 50
